<template>
  <div class="ml_auction_search">
    <van-form @submit="onSearch" class="ml_search_header">
      <van-search v-model="keywords" @focus="searchInputFocus=true" show-action placeholder="请输入搜索关键词" shape="round" autofocus
        clear-trigger="always" @search="onSearch" background="#f5f7f9">
        <template #action>
          <span @click="onSearch">搜索</span>
        </template>
      </van-search>
    </van-form>


    <div class="ml_customer_count">
      共找到{{ count }}个
    </div>
    <div class="ml_customer_line">
      <div class="ml_customer_line_content"></div>
    </div>   
    
    
    <template v-if="count > 0">
      <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了">
        <componentAuctionList :list="list" :sid="sid"></componentAuctionList>
      </van-list>
    </template>
    <template v-else>
      <componentNoData text="当前搜索无数据"></componentNoData>
    </template>

    <div class="ml_customer_search_history" v-if="searchInputFocus">
      <div class="ml_customer_search_history_content" v-if="auctionSearchHistory.length">
        <div class="ml_customer_search_history_header">
          <div class="ml_customer_search_history_content_title">
            搜索
          </div>
          <img src="../../assets/59.png" mode="aspectFill" class="ml_history_clear"
            @click.stop="removeCustomerHistory" />
        </div>
        <div class="ml_history_tab_list">
          <template v-for="(item, index) in auctionSearchHistory" :key="index">
            <div class="ml_history_tab_item" @click="onClickSearchText(index)">
              {{ item }}
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import componentNoData from "@/components/componentNoData.vue"
import componentAuctionList from '@/components/componentAuctionList.vue'
import { addAuctionSearchHistory } from '@/common/storage.js'

import { getAuctionList } from '@/utils/auction'
export default {
  components: {
    componentAuctionList,
    componentNoData,
  },
  data() {
    return {
      sid:'',
      gridType: null,
      auctionSearchHistory: [],
      // 搜索是否选中
      searchInputFocus: true,
      // 筛选文字
      keywords: "",

      pageIndex: 1,
      count: 0,
      list: [],

    };
  },
  mounted() {
    const that = this;
    that.sid = that.$route.query.sid
    that.storeId = that.$route.query.storeId || null;
    that.gridType = that.$route.query.gridType || "";
    that.order = that.$route.query.order || "";
    that.orderBy = that.$route.query.orderby || "";
    if (sessionStorage.getItem('carwinsAuctionSearchList')) {
      that.auctionSearchHistory = JSON.parse(sessionStorage.getItem('carwinsAuctionSearchList')) || []
    }

  },
  methods: {
    onSearch() {
      // 搜索
      const that = this;
      that.searchInputFocus = false;

      addAuctionSearchHistory(that, that.keywords)

      that.count = 0;
      that.list = [];

      that.pageIndex = 1;
      that.getList();
    },
    removeCustomerHistory() {
      // 清除缓存				
      this.auctionSearchHistory = []
      sessionStorage.setItem('carwinsAuctionSearchList', [])
    },
    onClickSearchText(e) {
      // 点击历史记录
      const that = this;
      this.keywords = that.auctionSearchHistory[e];
      that.onSearch();
    },
    getList() {
      // 列表
      const that = this;
      that.loading = true
      getAuctionList({
        "storeId": that.storeId,
        "gridType": that.gridType,
        "keywords": that.keywords,
        "order": that.order,
        "orderBy": that.orderBy,
        "pageNum": that.pageIndex,
        "pageSize": 10,
      }).then(res => {
        if (that.pageIndex > 1) {
          that.list = that.list.concat(res.data.list);
        } else {
          that.list = res.data.list;
        }

        that.count = res.data.total;

        that.pageNum++
        that.loading = false
        
        if (that.list.length >= that.count) {
          that.finished = true;
        }

      })
    },
    clearInput() {
      this.keywords = ''
      this.count = 0;
      this.list = [];

      this.pageIndex = 1;
      this.getList();
    }
  }
}
</script>

<style lang="scss" scoped>
.ml_auction_search {
  min-height: 100vh;
  background: #F5F7F9;

  .ml_search_header {
    width: 100%;
    background: #f5f7f9;
    display: flex;
    align-items: center;
    padding: 15px;
    box-sizing: border-box;
    .van-search{
      width: 100%;
      height: 35px;
      border-radius: 17px;
      padding: 0;
      .van-search__content{
        background: #ffffff;
        border-radius: 17px;
        padding-left: 10px;
        overflow: hidden;
      }
      .van-search__action{
        padding: 0;
        padding-left: 15px;
      }
    }
  }

  .ml_customer_count {
    font-size: 12px;
    color: #979797;
    padding:0 10px;
  }

  .ml_customer_line {
    padding: 0 10px;
    background-color: #FFFFFF;
    margin-bottom: 10px;

    .ml_customer_line_content {
      height: 1px;
      background-color: rgba($color: #E9E9E9, $alpha: 0.5);
    }
  }

  .ml_customer_search_history {
    position: fixed;
    left: 0;
    top: 65px;
    width: 100%;
    height: 100vh;
    background: #F5F7F9;

    .ml_customer_search_history_content {
      padding:0 15px 15px;

      .ml_customer_search_history_header {
        display: flex;
        justify-content: space-between;
      }

      .ml_customer_search_history_content_title {
        font-weight: bold;
      }

      .ml_history_clear {
        width: 13px;
        height: 13px;
        display: inline-block;
      }
    }

    .ml_history_tab_list {
      padding: 10px 0;

      .ml_history_tab_item {
        display: inline-block;
        margin: 0 10px 10px 0;
        background: #FFFFFF;
        border-radius: 18px;
        font-size: 12px;
        min-height: 24px;
        line-height: 24px;
        padding: 0 15px;
      }
    }
  }
}
</style>
